import { userAgent } from '@tink/tink-link-core/src/user-agent-detector';
import { base } from '../../lib-api/services/base';
import { applicationParameters } from '../application-parameters';
import { nestedPopup } from '../nested-popup';
import {
  buildRedirectHandlerUrl,
  buildRedirectToClientAppUrl,
  buildReferBackToClientUrl,
} from '../../routes';
import { routeBuilder } from '../../routes/routeBuilder';

type GetCredentialsAppUriPayload = {
  redirectToReferPage: boolean;
  navigateToInitialTinkLinkRedirect: boolean;
  windowLocation?: Location;
  isMobile?: boolean;
  isIframe?: boolean;
  appUri?: string;
  redirectPath?: string;
};

export const getCredentialsAppUri = ({
  redirectToReferPage = false,
  navigateToInitialTinkLinkRedirect,
  windowLocation = window.location,
  isMobile = userAgent.isMobile,
  isIframe = applicationParameters.get('isIframe'),
  appUri = applicationParameters.get('appUri'),
  redirectPath = '/redirect-handler',
}: GetCredentialsAppUriPayload): string => {
  const { origin, search: searchQuery, pathname } = windowLocation;
  const clientName = window.encodeURIComponent(base.clientName || '');

  if (appUri && appUri.endsWith('://')) {
    // This fixes a problem with appUri's where no authority is defined in the URI (eg. `demo://`) and would result in exception thrown by URI.create() in our API.
    // Eg. `demo://` is converted to `demo:///`
    appUri += '/';
  }

  if (appUri) {
    const clientAppDeeplink = window.encodeURIComponent(appUri);

    return buildRedirectToClientAppUrl({ origin, clientName, clientAppDeeplink });
  }

  // In iframe case on mobile devices we cannot confidently redirect user back to client's page.
  // More in https://tinkab.atlassian.net/browse/SDK-1185.
  const showReferBackToClientScreen = isIframe && isMobile && redirectToReferPage && !appUri;

  if (showReferBackToClientScreen) {
    nestedPopup.disableClosingPopup();

    return buildReferBackToClientUrl({ origin, clientName });
  }

  if (isIframe || (navigateToInitialTinkLinkRedirect && isMobile)) {
    return routeBuilder.buildTppToWebUrl.build({ origin, clientName });
  }

  const authorizationToken = base.authorizationToken || '';
  const trackingId = applicationParameters.get('trackingId') as string;

  return buildRedirectHandlerUrl({
    origin,
    pathname,
    searchQuery,
    trackingId,
    authorizationToken,
    redirectPath,
  });
};
